import { useAuth } from './contexts/AuthContext'
import { AuthProvider } from './contexts/AuthContext'
import { Toaster } from './components/ui/toaster'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from './components/auth/Login'
import Dashboard from './components/admin/Dashboard'
import AdminLayout from './components/layouts/AdminLayout'
import PrescriptionManagement from './components/admin/PrescriptionManagement'
import UserManagement from './components/admin/UserManagement'
import Settings from './components/admin/Settings'
import ProtectedRoute from './components/auth/ProtectedRoute'
import ForgotPassword from './components/auth/ForgotPassword'
import ResetPassword from './components/auth/ResetPassword'
import RenewalConfirmationPage from './components/prescriptions/RenewalConfirmationPage'
import ProductsPage from './pages/admin/products'
import UserDashboard from './components/user/UserDashboard'
import DatabaseManagement from './components/admin/DatabaseManagement'
import TestTools from './components/admin/test-tools/TestTools'
import NotificationLogs from './components/admin/NotificationLogs'

function AuthContent() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Login />
  }

  if (user.role === 'admin') {
    return (
      <ProtectedRoute>
        <AdminLayout>
          <Routes>
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/prescriptions" element={<PrescriptionManagement />} />
            <Route path="/admin/users" element={<UserManagement />} />
            <Route path="/admin/notifications" element={<NotificationLogs />} />
            <Route path="/admin/products" element={<ProductsPage />} />
            <Route path="/admin/database" element={<DatabaseManagement />} />
            <Route path="/admin/test-tools" element={<TestTools />} />
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </AdminLayout>
      </ProtectedRoute>
    )
  }

  // Regular user dashboard
  return (
    <Routes>
      <Route path="/" element={<UserDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/*" element={<AuthContent />} />
          
          {/* Public routes */}
          {/* Route was previously handled by RenewalPage but now redirects to RenewalConfirmationPage */}
          <Route path="/renew/:token" element={<RenewalConfirmationPage />} />
          <Route path="/renew-confirm/:token" element={<RenewalConfirmationPage />} />
          {/* Legacy routes - now redirect to the confirmation page directly */}
          <Route path="/renew-legacy/:token" element={<RenewalConfirmationPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
        </Routes>
        <Toaster />
      </Router>
    </AuthProvider>
  )
}

export default App